import { Outlet } from "react-router-dom";
import Header from "../../components/parcel/Header";
import Footer from "../../components/Footer";

export default function Layout() {
  return (
    <div className="App flex h-screen">
      <div className="flex-1 md:p-6 py-6 px-4">
        <Header />
        <div className="min-h-[82vh]">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}
